module.exports = __webpack_public_path__ + "55af1009bd9b56c590796468a753c5a8.png";